jQuery(document).ready(function ($) {

    var $overlays = $('.black-overlay');
    var $achievementPopups = $('.achievements-popup-container');
    var $messagePopups = $('.message-popup-container');

    $overlays.not(':first').addClass('closed');
    $achievementPopups.not(':first').addClass('closed');
    $messagePopups.not(':first').addClass('closed');

    $('.close-popup').click(function () {
        var $container = $(this).closest('.achievements-popup-container');
        var $overlay = $container.parent('.black-overlay');

        $container.remove();
        $overlay.remove();

        if ($('.achievements-popup-container').length > 0) {
            $('.achievements-popup-container:first').removeClass('closed');
            $('.achievements-popup-container:first').parent('.black-overlay').removeClass('closed');
        }
    });

    $('.close-message, .close').click(function () {
        var $container = $(this).closest('.message-popup-container');
        var $overlay = $container.parent('.black-overlay');

        $container.remove();
        $overlay.remove();

        if ($('.message-popup-container').length > 0) {
            $('.message-popup-container:first').removeClass('closed');
            $('.message-popup-container:first').parent('.black-overlay').removeClass('closed');
        }
    });
});

